import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { HubspotService } from '../../services/hubspot.service';
import {
  hubspotLogin,
  hubspotLoginSuccess,
  hubspotLoginFailure,
  hubspotCallback,
  hubspotCallbackSuccess,
  hubspotCallbackFailure,
  hubspotLogout,
  hubspotLogoutSuccess,
  hubspotLogoutFailure,
  googleLogin,
  googleLoginSuccess,
  googleLoginFailure,
  googleCallback,
  googleCallbackSuccess,
  googleCallbackFailure,
  googleLogout,
  googleLogoutSuccess,
  googleLogoutFailure,
} from './oauth.actions';
import { GoogleService } from 'src/app/services/google.service';

@Injectable()
export class OAuthEffects {
  hubspotLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(hubspotLogin),

      switchMap(() =>
        this.hubspotService.authorize().pipe(
          map((response) => {
            if (response.url) window.location.href = response.url;

            return hubspotLoginSuccess();
          }),
          catchError((error) => {
            return of(hubspotLoginFailure({ error }));
          })
        )
      )
    )
  );

  hubspotCallback$ = createEffect(() =>
    this.actions$.pipe(
      ofType(hubspotCallback), // Listen for the hubspot Callback action

      switchMap(({ code, user_id }) =>
        this.hubspotService.callback(code, user_id).pipe(
          map((response) => {
            if (!response || !response.data) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid Hubspot response');
            }

            return hubspotCallbackSuccess();
          }),
          catchError((error) => {
            return of(hubspotCallbackFailure({ error }));
          })
        )
      )
    )
  );

  hubspotLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(hubspotLogout), // Listen for the hubspot Callback action

      switchMap(({ user_id }) =>
        this.hubspotService.logout(user_id).pipe(
          map((response) => {
            if (!response || !response.data) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid Hubspot response');
            }

            return hubspotLogoutSuccess();
          }),
          catchError((error) => {
            return of(hubspotLogoutFailure({ error }));
          })
        )
      )
    )
  );

  googleLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(googleLogin),

      switchMap(() =>
        this.googleService.authorize().pipe(
          map((response) => {
            if (response.url) window.location.href = response.url;

            return googleLoginSuccess();
          }),
          catchError((error) => {
            return of(googleLoginFailure({ error }));
          })
        )
      )
    )
  );

  googleCallback$ = createEffect(() =>
    this.actions$.pipe(
      ofType(googleCallback),

      switchMap(({ code, user_id }) =>
        this.googleService.callback(code, user_id).pipe(
          map((response) => {
            if (!response || !response.data) {
              throw new Error('Invalid Google response');
            }

            return googleCallbackSuccess();
          }),
          catchError((error) => {
            return of(googleCallbackFailure({ error }));
          })
        )
      )
    )
  );

  googleLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(googleLogout),

      switchMap(({ user_id }) =>
        this.googleService.logout(user_id).pipe(
          map((response) => {
            if (!response || !response.data) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid Logout response');
            }

            return googleLogoutSuccess();
          }),
          catchError((error) => {
            return of(googleLogoutFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private hubspotService: HubspotService,
    private googleService: GoogleService
  ) {}
}
